import React, { useState } from 'react'
import {
    Col, FormFeedback, FormGroup, Input, InputGroup, Label, Row,
} from 'reactstrap'

// Shared markup over state the page holds. Both ways in need the same OpenDock login (the
// analysis to read with, the upload because applying signs in again), so it is typed once and
// survives switching between them.
function CredentialsFields({ idPrefix, userId, password, setUserId, setPassword, errors, touched }) {
    const [show, setShow] = useState(false)
    const invalidFor = field => touched && !!errors[field]
    const userField = `${idPrefix}-user`
    const passField = `${idPrefix}-password`

    return (
        <Row className="g-2" style={{ maxWidth: 480 }}>
            <Col sm={6}>
                <FormGroup className="mb-0">
                    <Label for={userField} className="mb-1 small">Username</Label>
                    <Input
                        id={userField}
                        type="email"
                        autoComplete="off"
                        placeholder="name@company.com"
                        value={userId}
                        invalid={invalidFor('userId')}
                        onChange={e => setUserId(e.target.value)}
                    />
                    <FormFeedback>{errors.userId}</FormFeedback>
                </FormGroup>
            </Col>
            <Col sm={6}>
                <FormGroup className="mb-0">
                    <Label for={passField} className="mb-1 small">Password</Label>
                    <InputGroup>
                        <Input
                            id={passField}
                            type={show ? 'text' : 'password'}
                            autoComplete="new-password"
                            value={password}
                            invalid={invalidFor('password')}
                            onChange={e => setPassword(e.target.value)}
                        />
                        {/* same control the reset-password screen uses */}
                        <button
                            type="button"
                            className="btn btn-light"
                            aria-label={show ? 'Hide password' : 'Show password'}
                            onClick={() => setShow(!show)}
                        >
                            <i className={show ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'} />
                        </button>
                    </InputGroup>
                    {invalidFor('password')
                        && <div className="invalid-feedback d-block">{errors.password}</div>}
                </FormGroup>
            </Col>
        </Row>
    )
}

export default CredentialsFields
